// extracted by mini-css-extract-plugin
module.exports = {"event":"startEvent_event__3lQ3u"};